import React from 'react';

const IcDatabase = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" /><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" /></svg>;

// Level 3 satellite nodes — cross (N/E/S/W) layout around the central data hub, per the design.
const NODES = [
    { cls: 'n-top', img: require('../../../../images/landing-pages/partner/data-layer-graphic/you.png'), alt: 'You' },
    { cls: 'n-right', img: require('../../../../images/landing-pages/partner/data-layer-graphic/partner-2.png'), alt: 'Partner 2' },
    { cls: 'n-bottom', img: require('../../../../images/landing-pages/partner/data-layer-graphic/partner-3.png'), alt: 'Partner 3' },
    { cls: 'n-left', img: require('../../../../images/landing-pages/partner/data-layer-graphic/partner-1.png'), alt: 'Partner 1' },
];

// dashed connector line from the hub to a node, with an arrowhead at each end
const Line = ({ x2, y2 }) => (
    <line x1="130" y1="130" x2={x2} y2={y2} stroke="rgba(74,103,255,0.5)" strokeWidth="1.5" strokeDasharray="4 4" markerStart="url(#partnerArrow)" markerEnd="url(#partnerArrow)" className="lp-partner-node-line" />
);

const PartnerLevelsSection = () => (
    <section className="lp-partner-levels">
        <div aria-hidden="true" className="lp-partner-levels-glow lp-partner-levels-glow--1" />
        <div aria-hidden="true" className="lp-partner-levels-glow lp-partner-levels-glow--2" />
        <div className="lp-partner-levels-inner">
            <div className="lp-partner-levels-head">
                <div className="eyebrow" data-lp-reveal><span />Partner levels</div>
                <h2 data-lp-reveal data-lp-delay="60">Three ways to partner, one platform.</h2>
                <p data-lp-reveal data-lp-delay="100">Start with a listing, layer on qualified leads, or go deep with a live data connection — you choose the depth.</p>
            </div>

            <div className="lp-partner-levels-grid">
                <div className="lp-partner-level" data-lp-reveal>
                    <span className="lvl">Level 1</span>
                    <h3>Get listed</h3>
                    <p>Your AppStore card goes live and surfaces to companies exactly when their flagged need matches your service.</p>
                </div>
                <div className="lp-partner-level" data-lp-reveal data-lp-delay="80">
                    <span className="lvl">Level 2</span>
                    <h3>Get qualified leads</h3>
                    <p>Everything in Level 1, plus a fact-finding checklist completed before you're introduced — so you know their stage and urgency upfront.</p>
                </div>
                <div className="lp-partner-level lp-partner-level--wide" data-lp-reveal data-lp-delay="160">
                    <div className="copy">
                        <span className="lvl">Level 3</span>
                        <h3>Full data integration</h3>
                        <p>Connect directly to Diligentsia's structured, verified company data. Your product auto-enriches in real time — no manual lookups, no stale records.</p>
                        <p style={{ marginTop: '10px', fontSize: '12px', fontStyle: 'italic' }}>=We do not share company's data without company's permission. The company connects with partner and authorizes access to its data.</p>
                    </div>
                    <div className="lp-partner-nodes" aria-hidden="true">
                        <svg width="260" height="260" viewBox="0 0 260 260" className="lp-partner-node-svg">
                            <defs>
                                <marker id="partnerArrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
                                    <path d="M0,0 L10,5 L0,10 Z" fill="rgba(74,103,255,0.75)" />
                                </marker>
                            </defs>
                            <Line x2="130" y2="48" />
                            <Line x2="212" y2="130" />
                            <Line x2="130" y2="212" />
                            <Line x2="48" y2="130" />
                        </svg>
                        <div className="hub"><IcDatabase /></div>
                        {NODES.map((n) => (
                            <span className={`node ${n.cls}`} key={n.cls}><img src={n.img} alt={n.alt} /></span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default PartnerLevelsSection;
